import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source, configuration) {
        super(configuration);
        this.o2y_1 = source;
      }
      t2x() {
        return this.o2y_1;
      }
      u2x(position) {
        return position < this.t2x().length ? position : -1;
      }
      i2u() {
        var source = this.t2x();
        var cpos = this.h2n_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.h2n_1 = cpos;
          return charToTokenClass(c);
        }
        this.h2n_1 = source.length;
        return 10;
      }
      e2u() {
        var current = this.h2n_1;
        if (current === -1)
          return false;
        var source = this.t2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.h2n_1 = current;
          return this.x2x(c);
        }
        this.h2n_1 = current;
        return false;
      }
      w2x() {
        var current = this.h2n_1;
        if (current === -1)
          return current;
        var source = this.t2x();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.h2n_1 = current;
        return current;
      }
      p2u(expected) {
        if (this.h2n_1 === -1) {
          this.y2x(expected);
        }
        var source = this.t2x();
        var cpos = this.h2n_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.h2n_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.y2x(expected);
        }
        this.h2n_1 = -1;
        this.y2x(expected);
      }
      v2u() {
        this.p2u(_Char___init__impl__6a9atx(34));
        var current = this.h2n_1;
        var closingQuote = indexOf(this.t2x(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.g2u();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false && this.h2n_1 > 0 ? this.h2n_1 - 1 | 0 : this.h2n_1;
          var s = this.h2n_1 === charSequenceLength(this.t2x()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.t2x(), position));
          var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.x2s(tmp$ret$1, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.t2x(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.t2x(), this.h2n_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.h2n_1 = closingQuote + 1 | 0;
        return substring(this.t2x(), current, closingQuote);
      }
      x2u(keyToMatch, isLenient) {
        var positionSnapshot = this.h2n_1;
        try {
          if (!(this.i2u() === 6))
            return null;
          var firstKey = this.s2u(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.z2x();
          if (!(this.i2u() === 5))
            return null;
          return this.s2u(isLenient);
        }finally {
          this.h2n_1 = positionSnapshot;
          this.z2x();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.t2m_1.v2o_1 ? new (StringJsonLexer())(source, json.t2m_1) : new (StringJsonLexerWithComments())(source, json.t2m_1);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
